import { useState, useEffect } from "react";
import useApi from "@/hooks/useApi";

/**
 * Fetches the site-wide global AI prompt (Layer 1 of the 3-layer prompt assembly).
 * Returns null while loading or if not set.
 */
export default function useGlobalPrompt(): string | null {
  const api = useApi();
  const [globalPrompt, setGlobalPrompt] = useState<string | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    api.messaging
      .get("SiteSettings", { signal: controller.signal })
      .then((r) => r.json())
      .then((data) => setGlobalPrompt(data.globalPrompt ?? null))
      .catch(() => setGlobalPrompt(null));
    return () => controller.abort();
  // api is stable (memoized by useApi), but including it satisfies exhaustive-deps
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return globalPrompt;
}
